import { BehaviorTimelineActionType } from '@/common/api/params/customer'
import { BehaviorActionType } from '@/common/model/recommend/behavior'

const ACTION_FILTERS = [
  { value: BehaviorActionType.VIEW, label: 'サイト閲覧' },
  { value: BehaviorActionType.VIEW_CATEGORY, label: 'カテゴリ閲覧' },
  { value: BehaviorActionType.VIEW_PRODUCT, label: '商品詳細閲覧' },
  { value: BehaviorActionType.CART, label: 'カート閲覧' },
  { value: BehaviorActionType.ORDER, label: '注文確定' }
]

export const behaviorActionTypeName = (actionType: BehaviorActionType) => {
  const action = ACTION_FILTERS.find((filter) => filter.value === actionType)
  return action ? action.label : ''
}

export const behaviorTimelineActionTypeName = (actionType: BehaviorTimelineActionType) => {
  const actionName = behaviorActionTypeName(actionType as BehaviorActionType)
  if (actionName) {
    return actionName
  }

  switch (actionType) {
    case BehaviorTimelineActionType.PURCHASE:
      return '注文確定（マスタ）'
    case BehaviorTimelineActionType.RECOMMENDATION_CLICK:
      return 'レコメンドをクリック'
    case BehaviorTimelineActionType.RECOMMENDATION_DELIVERY:
      return 'レコメンド表示'
    default:
      return ''
  }
}
